module.exports = __webpack_public_path__ + "media/rutin-large.fbc74c21.mp4";